import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef, OnInit, ChangeDetectorRef,
} from '@angular/core';
import {CalendarOptions} from "@fullcalendar/angular";
import {ApiService} from "../../../../services/api.service";
import {NzModalService} from "ng-zorro-antd/modal";
import {Router} from "@angular/router";
import {BreakpointObserver, BreakpointState} from "@angular/cdk/layout";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
  selector: 'app-calendar-modal',
  templateUrl: './calendar-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./calendar-modal.component.scss']
})
export class CalendarModalComponent implements OnInit {

  calendarOptions: CalendarOptions;
  private destroy$ = new Subject<void>();
  numberOfDays = 7;
  showCalendar = true;

  constructor(
    public api: ApiService,
    public modal: NzModalService,
    public router: Router,
    private breakpointObserver: BreakpointObserver,
    private cd: ChangeDetectorRef
  ) {

    this.calendarOptions = {
      initialView: 'dayGridWeekLarge',
      headerToolbar: {
        left: 'prev,next',
        center: 'title',
        right: ''
      },
      views: {
        dayGridWeek: {
          type: 'dayGrid',
          duration: {days: this.numberOfDays},
          buttonText: 'day'
        },
        dayGridWeekMobile: {
          type: 'dayGrid',
          duration: {days: 2},
          buttonText: 'day2'
        },
        dayGridWeekMedium: {
          type: 'dayGrid',
          duration: {days: 3},
          buttonText: 'day3'
        },
        dayGridWeekLarge: {
          type: 'dayGrid',
          duration: {days: 5},
          buttonText: 'day5'
        },
      },
      dateClick: this.handleDateClick.bind(this), // bind is important!
      events: (info, successCallback, failureCallback) => {

        this.api.apiPost('/api/jobs/calendar', info).then((res)=>{
            successCallback(res);
        }).catch((err)=>{
            failureCallback(err);
        })

      }
    };

  }

  set calendarView(data: string){
    this.showCalendar = false;
    const settings = this.calendarOptions;
    settings.initialView = data;
    this.calendarOptions = settings;
    setTimeout(()=>{
      this.showCalendar = true;
      this.cd.markForCheck();
    }, 100)

  }

  ngOnInit() {
    const CALENDAR_RESPONSIVE = {
      small: {
        breakpoint: '(max-width: 576px)',
        view: 'dayGridWeekMobile',
      },
      medium: {
        breakpoint: '(max-width: 768px)',
        view: 'dayGridWeekMedium',
      },
      large: {
        breakpoint: '(max-width: 960px)',
        view: 'dayGridWeekLarge',
      },
    };

    this.breakpointObserver
      .observe(
        Object.values(CALENDAR_RESPONSIVE).map(({breakpoint}) => breakpoint)
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((state: BreakpointState) => {
        const foundBreakpoint = Object.values(CALENDAR_RESPONSIVE).find(
          ({breakpoint}) => !!state.breakpoints[breakpoint]
        );
        if (foundBreakpoint) {
          this.calendarView = foundBreakpoint.view
        } else {
          this.calendarView = 'dayGridWeek'
        }
        this.cd.markForCheck();
        console.log(this.numberOfDays);
      });

  }

  handleDateClick(date: any) {


  }


}
